import ContainerPane from "./ContainerPane";

export default ContainerPane;
export { ContainerPane };
